import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid
} from '@material-ui/core'
import { useEffect, useState } from 'react'
import toastError from '../../errors/toastError'
import api from '../../services/api'
import { ButtonPrimary } from '../ButtonPrimary'
import { ButtonSecondary } from '../ButtonSecondary'
import { InputFieldText } from '../InputFieldText'
import { UsersFilter } from '../UsersFilter'
import { useStyles } from './style'

export function ChatModal({
  open,
  chat,
  type,
  handleClose,
  handleLoadNewChat,
  user
}) {
  const [users, setUsers] = useState([])
  const [title, setTitle] = useState('')
  const classes = useStyles()

  useEffect(() => {
    setTitle('')
    setUsers([])
    if (type === 'edit' && chat?.users) {
      const userList = chat.users.map(u => ({
        id: u.user.id,
        name: u.user.name
      }))
      setUsers(userList)
      setTitle(chat.title)
    }
  }, [chat, open, type])

  const handleSave = async () => {
    try {
      if (!title) {
        toastError('Por favor, preencha o título da conversa.')
        return
      }

      if (!users || users.length === 0) {
        toastError('Por favor, selecione pelo menos um usuário.')
        return
      }

      const totalParticipants = users.length + 1

      if (totalParticipants < 3) {
        toastError(
          'Para criar um grupo, selecione pelo menos 2 outros usuários.'
        )
        return
      }

      if (type === 'edit') {
        await api.put(`/chats/${chat.id}`, {
          users,
          title
        })
      } else {
        const { data } = await api.post('/chats', {
          users,
          title
        })
        handleLoadNewChat(data)
      }
      handleClose()
    } catch (err) {
      toastError(err)
    }
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className={classes.contentModal}
      fullWidth
      maxWidth="xs"
    >
      <DialogTitle className={classes.title} id="alert-dialog-title">
        {type === 'edit' ? 'Editar Grupo' : 'Novo Grupo'}
      </DialogTitle>
      <DialogContent dividers>
        <Grid spacing={2} container>
          <Grid xs={12} item>
            <InputFieldText
              label={'Nome do Grupo'}
              placeholder="Digite um nome para o grupo"
              value={title}
              onChange={e => setTitle(e.target.value)}
              variant="outlined"
              size="small"
              fullWidth
            />
          </Grid>
          <Grid xs={12} item>
            <UsersFilter
              label={'Usuários'}
              onFiltered={users => setUsers(users)}
              initialUsers={users}
              excludeId={user.id}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <ButtonSecondary onClick={handleClose} label={'Cancelar'} />

        <ButtonPrimary
          onClick={handleSave}
          variant="contained"
          label={'Salvar'}
        />
      </DialogActions>
    </Dialog>
  )
}
